/* eslint-disable prefer-template */
export const formatAddress = data => {
  const { street, street2, city, state, postalCode, country } = data

  return `
  ${
    // biome-ignore lint/style/useTemplate: TODO
    street ? street + ', ' : ''
  }
  ${
    // biome-ignore lint/style/useTemplate: TODO
    street2 ? street2 + ', ' : ''
  }
  ${
    // biome-ignore lint/style/useTemplate: TODO
    city ? city + ', ' : ''
  }
  ${state || ''}
  ${
    // biome-ignore lint/style/useTemplate: TODO
    postalCode ? postalCode + ', ' : ''
  }
  ${country || ''}`
}

export const formatAddressLabels = (country, addressParts = {}) => {
  const { administrativeArea, state } = addressParts
  const c = country ? country.toLowerCase() : ''
  switch (c) {
    case 'united kingdom':
      return {
        // biome-ignore lint/complexity/useOptionalChain: TODO
        stateName: (administrativeArea && administrativeArea.longName) || '',
        labels: {
          suburb: { label: 'City/Town', placeholder: 'City/Town' },
          state: {
            label: 'County',
            placeholder: 'Select County',
            defaultValue: 'Select County',
            valueProp: 'selected',
          },
          postalCode: { label: 'Post Code', placeholder: 'Post Code' },
        },
      }
    default:
      return {
        // biome-ignore lint/complexity/useOptionalChain: TODO
        stateName: (state && state.longName) || '',
        labels: {
          suburb: { label: 'City/Town', placeholder: 'City/Town' },
          state: {
            label: 'State/Province',
            placeholder: 'Select State/Province',
            defaultValue: 'Select State/Province',
            valueProp: 'selected',
          },
          postalCode: { label: 'Postal Code', placeholder: 'Postal Code' },
        },
      }
  }
}
